<template>
  <div class="zk-card">
    <div class="zk-card__header" v-if="$slots.header || header">
      <slot name="header">{{ header }}</slot>
    </div>
    <div class="zk-card__body" :style="bodyStyle">
      <slot></slot>
    </div>
    <div class="zk-card__footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'zk-card',
    props: ['header', 'bodyStyle']
  }
</script>



// WEBPACK FOOTER //
// card.vue?196cfb46